import { getText } from "shared/lib";
import { type TreeDescriptor } from "@/components/treeModule/lib";

import { Dialog, DialogContent, DialogTitle } from "shared/components";
import { MultiStemDiameterContent } from "@/components/treeModule/treeMeasurementsHelp/MultiStemDiameterContent";

export interface MultiStemDiameterDialogProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
  treeDescriptor: TreeDescriptor | undefined | null;
}

export function MultiStemDiameterDialog({
  onOpenChange,
  open,
  treeDescriptor,
}: MultiStemDiameterDialogProps) {
  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent className="max-h-[95vh] !max-w-[600px] overflow-auto">
        <DialogTitle>{getText("How to measure a tree")}</DialogTitle>

        <MultiStemDiameterContent treeDescriptor={treeDescriptor} />
      </DialogContent>
    </Dialog>
  );
}
